import { getCurrencySymbol } from '@utils/utils';

import { getNumberParts } from './utils';
import {
  OrginalPriceWrapper,
  OriginalPriceContainer,
  TourOriginalPriceContainer,
} from './style';
import { OrginalPriceProps } from './type';

const OriginalPrice = ({
  price,
  currency,
  size = 12,
  noLine,
  className,
  isTour = false,
  tourListing,
  control,
  color,
  height = 'auto',
  weight,
  decimalShow,
}: OrginalPriceProps) => {
  if (price === undefined) return null;
  const [whole, decimals] = getNumberParts(price);
  return (
    <OrginalPriceWrapper originalHeight={height} className={className || ''}>
      {isTour ? (
        tourListing ? (
          <TourOriginalPriceContainer size={size} noLine={noLine}>
            {decimalShow
              ? `${whole} ${currency}`
              : `${whole},${decimals} ${currency}`}
          </TourOriginalPriceContainer>
        ) : (
          <OriginalPriceContainer size={size} noLine={control}>
            {decimalShow
              ? `${whole} ${getCurrencySymbol(currency)}`
              : `${whole},${decimals} ${getCurrencySymbol(currency)}`}
          </OriginalPriceContainer>
        )
      ) : noLine ? (
        decimalShow ? (
          `${whole} ${getCurrencySymbol(currency)}`
        ) : (
          `${whole},${decimals} ${getCurrencySymbol(currency)}`
        )
      ) : (
        <OriginalPriceContainer
          size={size}
          noLine={control}
          color={color}
          weight={weight}
        >
          {decimalShow
            ? `${whole} ${getCurrencySymbol(currency)}`
            : `${whole},${decimals} ${getCurrencySymbol(currency)}`}
        </OriginalPriceContainer>
      )}
    </OrginalPriceWrapper>
  );
};

export default OriginalPrice;
